export default __webpack_public_path__ + "static/favicon-196-2b7b9351d2f893ac812c0ab411d7f3e8.png";